import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=e5bbd0a6&"
import script from "./Design.vue?vue&type=script&lang=ts&"
export * from "./Design.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports